exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-show-history{\r\n    background-color: #DCDADB;\r\n    margin-top: 28px;\r\n}\r\n\r\n.btn-default-height{\r\n    height: 38px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reglas/reglas.editor.component.css
// module id = ../../../../../src/app/private/reglas/reglas.editor.component.css
// module chunks = main